import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder } from '@angular/forms';
import { BaseModalDirective } from '../../base-modal';

@Component({
  selector: 'nh-id-verification-serviceDown',
  templateUrl: './id-verification-serviceDown.component.html',
  styleUrl: './id-verification-serviceDown.component.scss',
  standalone: false
})
export class IdVerificationServiceDownComponent extends BaseModalDirective implements OnInit {
  isMobileUser: boolean = false;
  constructor(
    protected modalRef: BsModalRef,
    protected builder: FormBuilder,
    protected router: Router,
  ) {
    super(modalRef, builder);
  }

  ngOnInit(): void {
    this.isMobileUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;
  }

  onContinue(): void {
    this.hide(true);
    sessionStorage.setItem('ridpErrorReload', 'true');
    window.location.reload();
  }
}
